import { render, staticRenderFns } from "./VendorReviewResolutionUI.vue?vue&type=template&id=3bfccbc8&scoped=true&"
import script from "./VendorReviewResolutionUI.vue?vue&type=script&lang=js&"
export * from "./VendorReviewResolutionUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfccbc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
